/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

const slugifyPathSegment = (value: string): string =>
  value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

/**
 * Builds the relative hotel-details slug (location/hotel/id). Consumers prepend
 * their own route prefix (e.g. `/hotels/details/` or `/details/`).
 */
export const buildHotelDetailsSlug = (
  hotelId: string,
  locationName?: string,
  hotelName?: string,
): string => {
  const encodedHotelId = encodeURIComponent(hotelId);
  const locationSlug = locationName ? slugifyPathSegment(locationName) : '';
  const hotelSlug = hotelName ? slugifyPathSegment(hotelName) : '';

  if (locationSlug && hotelSlug) {
    return `${locationSlug}/${hotelSlug}/${encodedHotelId}`;
  }

  return encodedHotelId;
};

/** @deprecated Use buildHotelDetailsSlug */
export const buildDetailRoute = buildHotelDetailsSlug;
